module.exports = __webpack_public_path__ + "static/media/industries-food-s.153efe3e.webp";